import {
  TARGETING_AND_ADVERTISING_COOKIES_ID,
  hasConsent,
} from "@asosteam/asos-web-consent";
import { getCategoryId } from "../../state/modules/category/selectors";
import {
  getAllAppliedRefinements,
  getSearchTerm,
  getSort,
  refreshAdvertisementBeacons,
  sendPlacementOnLoadBeacon,
} from "../../state/modules/search";
import getProductsForPage from "../../state/modules/search/domains/pagination/selectors/getProductsForPage";
import getPageNumber from "../../state/modules/search/domains/pagination/selectors/getPageNumber";
import getSponsoredProducts from "../../state/modules/search/advertising/selectors/getSponsoredProducts";
import getSponsoredProductIds from "../../state/modules/search/advertising/selectors/getSponsoredProductIds";
import { getIsSearchPage } from "../../state/modules/page/selectors";
import getFiltersString from "./getFiltersString";
import makeCriteoRequest from "./makeCriteoRequest";
import shouldRefreshBeacons from "./shouldRefreshBeacons";
import shouldAttemptCriteoRequest from "./shouldAttemptCriteoRequest";
import recordDeliveryDecision from "./recordDeliveryDecision";
import deriveReason from "./deriveReason";

const initialiseAdvertsSdk = async ({ dispatch, getState }) => {
  const state = getState();
  const pageNumber = getPageNumber(state);

  const productsCount = getProductsForPage(state, pageNumber).length;
  const sponsoredProductsCount = getSponsoredProducts(state).length;
  const organicProductsCount = productsCount - sponsoredProductsCount;

  const sponsoredProductIds = getSponsoredProductIds(state);
  const isSorted = !!getSort(state);

  const categoryId = getCategoryId(state);
  const searchTerm = getSearchTerm(state);
  const isSearchPage = getIsSearchPage(state);

  const deliveryAttempted = shouldAttemptCriteoRequest({
    categoryId,
    searchTerm,
  });
  const painted = shouldRefreshBeacons({ sponsoredProductIds, isSorted });

  recordDeliveryDecision({
    deliveryAttempted,
    painted,
    isSorted,
    sponsoredProductIdsCount: sponsoredProductIds
      ? sponsoredProductIds.split("|").filter(Boolean).length
      : 0,
    pageNumber,
    isSearchPage,
    consentC0004: hasConsent([TARGETING_AND_ADVERTISING_COOKIES_ID]),
    reason: deriveReason({
      deliveryAttempted,
      painted,
      isSorted,
      sponsoredProductIds,
    }),
  });

  if (!deliveryAttempted) return;

  const {
    products: sponsoredProducts,
    OnLoadBeacon: onLoadBeacon,
    OnViewBeacon: onViewBeacon,
  } = await makeCriteoRequest({
    pageNumber,
    organicProductsCount,
    categoryId,
    searchTerm,
    filters: getFiltersString(getAllAppliedRefinements(state)),
    sponsoredProductIds,
    isSearchPage,
    isSorted,
  });

  if (painted) {
    dispatch(
      refreshAdvertisementBeacons({
        sponsoredProducts,
        onLoadBeacon,
        onViewBeacon,
      }),
    );
    dispatch(sendPlacementOnLoadBeacon());
  }
};

export default initialiseAdvertsSdk;
